import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BuildingType } from '../../data';

@Component({
    selector: '[app-marketplace-roof]',
    templateUrl: './marketplace-roof.component.html',
    styleUrl: './marketplace-roof.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MarketplaceRoofComponent {
  type = input<BuildingType>();
}
